import { AuthorizedParty } from "./auth.typer";

export const loggUt = (isAutoLogout: boolean = false) => {
  const redirectUrl = isAutoLogout
    ? `?redirect=/utlogget?redirect=${window.location.pathname}`
    : "";

  sessionStorage.clear();

  window.location.replace(`${origin}/oauth2/logout${redirectUrl}`);
};

export const findPartOrSubunit = (
  parts: AuthorizedParty[],
  partId?: string,
): AuthorizedParty | undefined => {
  for (const part of parts) {
    if (part.personId === partId || part.organizationNumber === partId) {
      return part;
    }
    if (part.subunits) {
      const found = findPartOrSubunit(part.subunits, partId);
      if (found) {
        return found;
      }
    }
  }
  return undefined;
};
